import React from "react";
import { useSelector } from "react-redux";
import cn from "clsx";
import SyteDiscoveryBanner from "../../../components/syte/syteDiscoveryBanner";
import {
  selectCdnImageSettings,
  selectSyteSettings
} from "../../../util/selectors";
import { selectProductDetails } from "../selectors";
import { AnalyticService } from "../../../services";
import { useIsRTL } from "../../../hooks";
import "./style.scss";

const PdpSyteDiscoveryBanner = () => {
  const configCdnImagesSettings = useSelector(selectCdnImageSettings);
  const configSyteSettings = useSelector(selectSyteSettings);
  const item = useSelector(selectProductDetails);
  const isRTL = useIsRTL();

  if (!configSyteSettings?.enableShopSimilarSection) return null;

  return (
    <div
      className={cn("pdp_discovery_banner", {
        arabic: isRTL
      })}
    >
      <SyteDiscoveryBanner
        key={item.id}
        sku={item.id}
        productImgPath={`${configCdnImagesSettings?.main}${item?.captionImageURL}`}
        placement="pdp-discovery-banner"
        handleClick={AnalyticService.syte.trackSyteSearchProductPage}
        details={item}
      />
    </div>
  );
};
export default PdpSyteDiscoveryBanner;
